export const EVENT_DATE = 'eventDate';

export const EVENT_TYPES = {
  EditFields: 'Edit Fields',
  Modify: 'Modify',
  View: 'View',
  Create: 'Create',
  Reject: 'Reject',
  Restore: 'Restore',
};

export const COLUMN_WIDTH = {
  USER: '40%',
  EVENT: '30%',
};
